import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from '../Context/Context';
import {isTokenExpired} from '../helper/jwt'
function PrivateRoute({ children }) {
  const { user, isLoading } = useContext(AppContext);

  if (isLoading) return null;

  if (!user?.token||isTokenExpired(user?.token)) {
    return <Navigate to="/login" />;
  }

  return children;
}

export default PrivateRoute;
